import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter, map, mergeMap, startWith } from 'rxjs/operators';
import { TablerIconsModule } from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterModule, TablerIconsModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: [],
})
export class AppBreadcrumbComponent {
  // @Input() layout;
  pageInfo: Data | any = Object.create(null);
  // myurl: any = this.router.url.slice(1).split('/');
  myurl: string[] = this.router.url.slice(1).split('/');
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {
    // Helper function to get deepest route
    const getDeepestRoute = (route: ActivatedRoute): ActivatedRoute => {
      while (route.firstChild) {
        route = route.firstChild;
      }
      return route;
    };

    // Subscribe to route data changes on navigation end AND on initialization
    // This ensures we catch the title both on navigation and on page refresh
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => getDeepestRoute(route)),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
      )
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        if (event && event['title']) {
          this.titleService.setTitle(event['title']);
          this.pageInfo = event;
          this.myurl = this.router.url.slice(1).split('/');
        }
      });

    // Also subscribe to current route data on initialization (for page refresh)
    // This ensures we get the title even if NavigationEnd already fired or resolver completes later
    const deepestRoute = getDeepestRoute(this.activatedRoute);
    if (deepestRoute && deepestRoute.outlet === 'primary') {
      deepestRoute.data.subscribe((data) => {
        if (data && data['title']) {
          this.titleService.setTitle(data['title']);
          this.pageInfo = data;
          this.myurl = this.router.url.slice(1).split('/');
        }
      });
    }
  }
}
